<ng-container>
    <div class="asGraph">
        <svg viewBox="0 0 100 26" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <rect [attr.x]="0" [attr.y]="0" [attr.width]="100" [attr.height]="26" style="fill: #eee" rx="2" />
            <rect [attr.x]="0" [attr.y]="0" [attr.width]="relVal" [attr.height]="26" style="fill: grey" rx="2" />
        </svg>
    </div>
</ng-container>